import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 1.5, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "parameter calculation",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>Using ζ = Z<sub>e</sub>(f<sub>s</sub>) / R<sub>e</sub>, we get: <span style="font-weight:700">
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <mi mathvariant="bold">ζ</mi>
                  <mo mathvariant="bold">=</mo>
                  <mn mathvariant="bold">15.71</mn>
                  </math>
                  <li>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>ms</mi> </mrow> </msub> <mo>=</mo>
                  <msqrt> <mi>ζ</mi></msqrt>
                  <mfrac>
                  <mrow> <msub> <mrow> <mi>f</mi> </mrow><mrow> <mi>s</mi> </mrow> </msub></mrow>
                  <mrow> <msub> <mrow> <mi>f</mi> </mrow> <mrow> <mn>2</mn> </mrow></msub> <mo>-</mo> <msub> <mrow> <mi>f</mi> </mrow> <mrow> <mn>1</mn> </mrow> </msub></mrow>
                  </mfrac> <mo>=</mo> <msqrt> <mn>15.71</mn></msqrt>
                  <mfrac>
                  <mrow> <mn> 20.8 </nm></mrow>
                  <mrow> <mn>34.8</mn> <mo>-</mo> <mn>11.7</mn></mrow>
                  </mfrac><mo>=</mo> <mn mathvariant="bold">3.57</mn>
                  </math>
                  <li>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>es</mi> </mrow> </msub> <mo>=</mo>
                  <mfrac>
                  <mrow> <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>ms</mi> </mrow> </msub><msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>es</mi> </mrow> </msub></mrow>
                  <mrow> <mi>ζ</mi> <mo>-</mo> <mn>1</mn></mrow>
                  </mfrac> <mo>=</mo>
                  <mfrac>
                  <mrow> <mn> 3.57 </nm></mrow>
                  <mrow> <mn>15.71</mn> <mo>-</mo> <mn>1</mn></mrow>
                  </mfrac><mo>=</mo> <mn mathvariant="bold">3.57</mn>
                  </math>
                  <li>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>ts</mi> </mrow> </msub> <mo>=</mo>
                  <mfrac>
                  <mrow> <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>ms</mi> </mrow> </msub><msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>es</mi> </mrow> </msub></mrow>
                  <mrow> <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>ms</mi> </mrow> </msub> <mo>+</mo> <msub> <mrow> <mi>Q</mi> </mrow><mrow> <mi>es</mi> </mrow> </msub> </mrow>
                  </mfrac> <mo>=</mo> <mn mathvariant="bold">0.23</mn>
                  </math>
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                textAlign: "center",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-4.svg`,
                },
              },
              styles: {
                maxHeight: "165px",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
